import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { RouterModule } from "@angular/router";
import { appRoutes } from "./routes";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UserService } from './services/user/user.service';

import { RoleService } from './services/role/role.service';

import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { JwtService } from './auth/jwt.service';
import { DataSharingService } from './auth/data-sharing.service';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './user/login/login.component';
import { RegisterComponent } from './user/register/register.component';
import { HeaderComponent } from './shared/layout/header/header.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { VendorComponent } from './sitemodules/vendors/vendor/vendor.component';
import { PreloadComponent } from './shared/animations/preload/preload.component';
import { AdduserComponent } from './sitemodules/vendors/adduser/adduser.component';
import { RoleguardServiceGuard } from './auth/roleguard-service.guard';
import { PurchaseorderComponent } from './sitemodules/purchase/purchaseorder/purchaseorder.component';
import { AddpurchaseorderComponent } from './sitemodules/purchase/addpurchaseorder/addpurchaseorder.component';
import { AddpurchaselinesComponent } from './sitemodules/purchase/addpurchaselines/addpurchaselines.component';
import { SsgmasterComponent } from './sitemodules/enlistment/ssgmaster/ssgmaster.component';
import { SmgmasterComponent } from './sitemodules/enlistment/smgmaster/smgmaster.component';
import { DataTableModule } from "angular-6-datatable";
import { VendordashboardComponent } from './sitemodules/dashboards/vendordashboard/vendordashboard.component';
import { AdmindashboardComponent } from './sitemodules/dashboards/admindashboard/admindashboard.component';
import { MydashboardComponent } from './sitemodules/dashboards/mydashboard/mydashboard.component';
import { VendorregistrationComponent } from './sitemodules/enlistment/enlistmentforms/vendorregistration/vendorregistration.component';
import { SmgmanufacturerComponent } from './sitemodules/enlistment/enlistmentforms/smgmanufacturer/smgmanufacturer.component';
import { SmgdealerComponent } from './sitemodules/enlistment/enlistmentforms/smgdealer/smgdealer.component';
import { SsgdealerComponent } from './sitemodules/enlistment/enlistmentforms/ssgdealer/ssgdealer.component';
import { SsgcontractorComponent } from './sitemodules/enlistment/enlistmentforms/ssgcontractor/ssgcontractor.component';
import { EvaluatevendorComponent } from './sitemodules/evaluation/evaluatevendor/evaluatevendor.component';
//import { AgGridModule } from 'ag-grid-angular';
import { EvalsmgdealerComponent } from './sitemodules/evaluation/evalsmgdealer/evalsmgdealer.component';
import { EvalvendregistationComponent } from './sitemodules/evaluation/evalvendregistation/evalvendregistation.component';
import { EvalsmgmanufacturerComponent } from './sitemodules/evaluation/evalsmgmanufacturer/evalsmgmanufacturer.component';
import { EvalssgcontractorComponent } from './sitemodules/evaluation/evalssgcontractor/evalssgcontractor.component';
import { EvalssgdealerComponent } from './sitemodules/evaluation/evalssgdealer/evalssgdealer.component';
import { VendorscoreComponent } from './sitemodules/evaluation/vendorscore/vendorscore.component';
import { EnqassignedComponent } from './sitemodules/tendering/admin/enqassigned/enqassigned.component';
import { EnqlistadminComponent } from './sitemodules/tendering/admin/enqlistadmin/enqlistadmin.component';
import { PopoverModule } from 'ngx-popover';
import { TechquoteComponent } from './sitemodules/tendering/admin/quotesform/techquote/techquote.component';
import { PricequoteComponent } from './sitemodules/tendering/admin/quotesform/pricequote/pricequote.component';
import { TechpriceComponent } from './sitemodules/tendering/admin/quotesform/techprice/techprice.component';
import { MdluploadComponent } from './sitemodules/engineering/admin/mdlupload/mdlupload.component';
import { MdllistComponent } from './sitemodules/engineering/admin/mdllist/mdllist.component';
import { EnqlistvendorComponent } from './sitemodules/tendering/vendor/enqlistvendor/enqlistvendor.component';
import { EnqsubmittedComponent } from './sitemodules/tendering/admin/enqsubmitted/enqsubmitted.component';
import { PricequotevendorComponent } from './sitemodules/tendering/vendor/quotesformvendor/pricequotevendor/pricequotevendor.component';
import { TechquotevendorComponent } from './sitemodules/tendering/vendor/quotesformvendor/techquotevendor/techquotevendor.component';
import { TechpricevendorComponent } from './sitemodules/tendering/vendor/quotesformvendor/techpricevendor/techpricevendor.component';
import { AssigndrawingComponent } from './sitemodules/engineering/admin/assigndrawing/assigndrawing.component';
import { DrawingcommentsadminComponent } from './sitemodules/engineering/admin/drawingcommentsadmin/drawingcommentsadmin.component';
import { MdllistvendorComponent } from './sitemodules/engineering/vendor/mdllistvendor/mdllistvendor.component';
import { SubmitdrawingComponent } from './sitemodules/engineering/vendor/submitdrawing/submitdrawing.component';
import { DrawingcommentsvendorComponent } from './sitemodules/engineering/vendor/drawingcommentsvendor/drawingcommentsvendor.component';
import { SubmitteddrawingsComponent } from './sitemodules/engineering/vendor/submitteddrawings/submitteddrawings.component';
import { SubmdrawingsadminComponent } from './sitemodules/engineering/admin/submdrawingsadmin/submdrawingsadmin.component';
import { InspectioncallComponent } from './sitemodules/inspection/inspectioncall/inspectioncall.component';
import { InvoicetrackreqComponent } from './sitemodules/invoice/invoicetrackreq/invoicetrackreq.component';
import { MessageComponent } from './sitemodules/Message/message/message.component';
import { TobeevaluatedlistComponent } from './sitemodules/evaluation/tobeevaluatedlist/tobeevaluatedlist.component';
import { SettingsComponent } from './user/settings/settings.component';
import { ProfileComponent } from './user/profile/profile.component';
import { SiteuserComponent } from './sitemodules/siteuser/siteuserview/siteuser.component';
import { SiteusereditComponent } from './sitemodules/siteuser/siteuseredit/siteuseredit.component';
import { SiteuseraddComponent } from './sitemodules/siteuser/siteuseradd/siteuseradd.component';
import { InvoicelistComponent } from './sitemodules/invoice/invoicelist/invoicelist.component';
import { SubmittedquoteComponent } from './sitemodules/tendering/vendor/submittedquote/submittedquote.component';
import { InvoiceuploadComponent } from './sitemodules/invoice/invoiceupload/invoiceupload.component';
import { InspectionlistComponent } from './sitemodules/inspection/inspectionlist/inspectionlist.component';
import { InvoiceuplodedComponent } from './sitemodules/invoice/invoiceuploded/invoiceuploded.component';
import { MDCCComponent } from './sitemodules/inspection/Vendor/mdcc/mdcc.component';
import { PurchaseheaderComponent } from './sitemodules/engineering/admin/purchaseheader/purchaseheader.component';
import { PurchaselinesComponent } from './sitemodules/engineering/admin/purchaselines/purchaselines.component';
import { EnlistuserComponent } from './sitemodules/enlistment/enlistuser/enlistuser.component';
import { AdminnavinvoiceComponent } from './sitemodules/invoice/adminnavinvoice/adminnavinvoice.component';
import { VendornavinvoiceComponent } from './sitemodules/invoice/vendornavinvoice/vendornavinvoice.component';
import { PaymentpageComponent } from './sitemodules/invoice/paymentpage/paymentpage.component';
import { VieworderadminComponent } from './sitemodules/engineering/admin/vieworderadmin/vieworderadmin.component';
import { ViewordervendorComponent } from './sitemodules/engineering/vendor/viewordervendor/viewordervendor.component';
import { VendororderComponent } from './sitemodules/engineering/vendor/vendororder/vendororder.component';
import { ViewinvoicedetailComponent } from './sitemodules/invoice/viewinvoicedetail/viewinvoicedetail.component';
import { AddtransportdtlsComponent } from './sitemodules/engineering/admin/addtransportdtls/addtransportdtls.component';
import { FinancedashboardComponent } from './sitemodules/dashboards/financedashboard/financedashboard.component';
import { PurchasedashboardComponent } from './sitemodules/dashboards/purchasedashboard/purchasedashboard.component';
import { AdminmessageComponent } from './sitemodules/Message/adminmessage/adminmessage.component';
import { VendormessageComponent } from './sitemodules/Message/vendormessage/vendormessage.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MessagelistComponent } from './sitemodules/Message/messagelist/messagelist.component';
import { ResentquoteComponent } from './sitemodules/tendering/admin/quotesform/resentquote/resentquote.component';
import { SiteincdashboardComponent } from './sitemodules/dashboards/siteincdashboard/siteincdashboard.component';
import { ViewwnlistmentComponent } from './sitemodules/enlistment/enlistmentforms/viewwnlistment/viewwnlistment.component';
import { TransportdashboardComponent } from './sitemodules/dashboards/transportdashboard/transportdashboard.component';
import { UploaddataComponent } from './sitemodules/MasterData/uploaddata/uploaddata.component';
import { GrnformComponent } from './sitemodules/grn/grnform/grnform.component';
import { GrnlistComponent } from './sitemodules/grn/grnlist/grnlist.component';
import { CreditmemoComponent } from './sitemodules/creditmemo/creditmemo/creditmemo.component';
import { CreditmemolinesComponent } from './sitemodules/creditmemo/creditmemolines/creditmemolines.component';
import { EditroleComponent } from './sitemodules/rolemanagement/editrole/editrole.component';
import { RoleassignmentComponent } from './sitemodules/rolemanagement/roleassignment/roleassignment.component';
import { UserroleComponent } from './sitemodules/rolemanagement/userrole/userrole.component';
import { ViewroleComponent } from './sitemodules/rolemanagement/viewrole/viewrole.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { AgGridModule } from 'ag-grid-angular';
import { ToastrModule } from 'ngx-toastr';
import { ButtonRendererComponent } from './button-renderer.component';
import { ResetButtonRendererComponent } from './resetbutton-renderer.component';
import { Button3RendererComponent } from './button3-renderer.component';
import { AssignsurveylinkComponent } from './sitemodules/vendors/assignsurveylink/assignsurveylink.component';
import { PrescreeningComponent } from './sitemodules/PreScreening/prescreening/prescreening.component';
import { ProjectinfoComponent } from './sitemodules/purchase/projectinfo/projectinfo.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { StartSurveyComponent } from './sitemodules/vendors/StartSurvey/StartSurvey.component';
import { AnswersComponent } from './sitemodules/PreScreening/answers/answers.component';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { ExportButtonRendererComponent } from './exportbutton-renderer.component';
import { ArchivedataComponent } from './sitemodules/ArchiveAndUnArchive/archivedata/archivedata.component';
import { SentryapibuttonRendererComponent } from './sentryapibutton-renderer.component';
import { CustomUrlSerializer } from './sitemodules/vendors/StartSurvey/custom-url-serializer';
import { UrlSerializer } from '@angular/router';
import { UnarchivedataComponent } from './sitemodules/ArchiveAndUnArchive/unarchivedata/unarchivedata.component';

@NgModule({
  declarations: [
    EditroleComponent,
    RoleassignmentComponent,
    UserroleComponent,
    ViewroleComponent,
    AppComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    VendorComponent,
    PreloadComponent,
    AdduserComponent,
    PurchaseorderComponent,
    AddpurchaseorderComponent,
    AddpurchaselinesComponent,
    SsgmasterComponent,
    SmgmasterComponent,
    AnswersComponent,
    VendordashboardComponent,
    AdmindashboardComponent,
    MydashboardComponent,
    VendorregistrationComponent,
    SmgmanufacturerComponent,
    SmgdealerComponent,
    SsgdealerComponent,
    SsgcontractorComponent,
    EvaluatevendorComponent,
    EvalsmgdealerComponent,
    EvalvendregistationComponent,
    EvalsmgmanufacturerComponent,
    StartSurveyComponent,
    EvalssgcontractorComponent,
    EvalssgdealerComponent,
    VendorscoreComponent,
    EnqassignedComponent,
    EnqlistadminComponent,
    TechquoteComponent,
    PricequoteComponent,
    TechpriceComponent,
    MdluploadComponent,
    MdllistComponent,
    EnqlistvendorComponent,
    EnqsubmittedComponent,
    PricequotevendorComponent,
    TechquotevendorComponent,
    TechpricevendorComponent,
    AssigndrawingComponent,
    DrawingcommentsadminComponent,
    MdllistvendorComponent,
    SubmitdrawingComponent,
    DrawingcommentsvendorComponent,
    SubmitteddrawingsComponent,
    SubmdrawingsadminComponent,
    InspectioncallComponent,
    InvoicetrackreqComponent,
    MessageComponent,
    TobeevaluatedlistComponent,
    SettingsComponent,
    ProfileComponent,
    SiteuserComponent,
    SiteusereditComponent,
    SiteuseraddComponent,
    InvoicelistComponent,
    SubmittedquoteComponent,
    InvoiceuploadComponent,
    InspectionlistComponent,
    InvoiceuplodedComponent,
    MDCCComponent,
    PurchaseheaderComponent,
    PurchaselinesComponent,
    EnlistuserComponent,
    AdminnavinvoiceComponent,
    VendornavinvoiceComponent,
    PaymentpageComponent,
    VieworderadminComponent,
    ViewordervendorComponent,
    VendororderComponent,
    ViewinvoicedetailComponent,
    AddtransportdtlsComponent,
    FinancedashboardComponent,
    PurchasedashboardComponent,
    AdminmessageComponent,
    VendormessageComponent,
    MessagelistComponent,
    ResentquoteComponent,
    SiteincdashboardComponent,
    ViewwnlistmentComponent,
    TransportdashboardComponent,
    UploaddataComponent,
    GrnformComponent,
    GrnlistComponent,
    CreditmemoComponent,
    CreditmemolinesComponent,
    ButtonRendererComponent,
    Button3RendererComponent,
    ResetButtonRendererComponent,
    ExportButtonRendererComponent,
    AssignsurveylinkComponent,
    PrescreeningComponent,
    ProjectinfoComponent,
    ArchivedataComponent,
    SentryapibuttonRendererComponent,
    UnarchivedataComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    CKEditorModule,
    RouterModule.forRoot(appRoutes),
    DataTableModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    PopoverModule,
    ModalModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
    }),
    AgGridModule.withComponents([[ButtonRendererComponent, Button3RendererComponent, ResetButtonRendererComponent, ExportButtonRendererComponent, SentryapibuttonRendererComponent]])
  ],
  providers: [UserService, RoleService, AuthGuard, RoleguardServiceGuard, JwtService, DataSharingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: UrlSerializer,
      useClass: CustomUrlSerializer
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
